import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const ButtonContainer = styled(Box)`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 1rem;
`;
